// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__MYv0O","tooltip__label":"styles_tooltip__label__JaAFt","tooltip__value":"styles_tooltip__value__T0pn2"};